export default __webpack_public_path__ + "static/media/Path 97884.bd492120.svg";